<template>
  <div class="shadow-sm rounded-2 mr-2">
    <tr class="d-flex align-items-center font-weight-600 h-auto purchase-item-row">
      <td class="col-5 pi-full">
        <div class="w-100">
          <Select2 container-class="form-group mt-auto" :multiple="false" :show-search="true"
            :selectClass="'form-select form-control-lg form-select-solid'" :name="`purchase-product-${index}`" @update:modelValue="() => itemData.lot_id=''"
            :isRequired="true" :placeholderText="$t('purchase.product')" v-model="itemData.product_sale_element_id">
            <option v-for="(item, idx) in filterProductSaleElements(index)" :key="idx" :value="item.id">{{ item.declination_title }}</option>
          </Select2>
        </div>
      </td>
      <td class="col-2 pi-full">
        <div class="w-100">
          <Select2 container-class="form-group mt-auto" :multiple="false" :show-search="true"
            :selectClass="'form-select form-control-lg form-select-solid'" :name="`purchase-lot-${index}`"
            :placeholderText="$t('purchase.lot')" v-model="itemData.lot_id">
            <option v-for="(lot, key) in productLots" :key="key" :value="lot.id">{{ lot?.lot?.name }} ({{ lot?.lot.item_number }})</option>
          </Select2>
        </div>
      </td>
      <td class="w-150px pi-third" :data-label="$t('purchase.quantity')">
        <div class="h-100">
          <input class="form-control form-control-solid" v-model="itemData.quantity" type="number" min="1"
            placeholder="1005">
        </div>
      </td>
      <td class="w-150px pi-third" :data-label="$t('purchase.price')">
        <div class="h-100">
          <input class="form-control form-control-solid fw-bolder" v-model="itemData.purchase_price" min="1"
            type="number">
        </div>
      </td>
      <td class="w-150px pi-third" :data-label="$t('purchase.amount')">
        <div class="form-control border-0">
          {{ total ?? 0 }}
        </div>
      </td>
      <td class="w-100px pi-full" style="text-align: end !important;">
        <a class="btn btn-sm btn-icon btn-bg-light btn-active-color-danger py-3" @click.prevent="deleteRow(index)">
          <i class="bi bi-trash-fill fs-5"></i>
        </a>
      </td>
    </tr>
    <tr class="d-flex align-items-center h-auto">
      <td class="col" colspan="6">
        <div class="input-group flex-nowrap">
          <div class="overflow-hidden flex-grow-1">
            <Select2 container-class="form-group mt-auto" :multiple="true" :show-search="true"
              :selectClass="'form-control form-control-solid form-select form-select-solid rounded-end-0 border-start'"
              :name="`purchase-product-${index}-tax`"
              :placeholderText="$t('purchase.placeholder_taxes')" v-model="itemData.taxes" :IsInputGroup="true"
              icon="bi bi-plus" :clickAddon="openTaxModal">
              <option v-for="(tax, index) in taxes" :key="index" :value="tax.id">{{ tax.title }}</option>
            </Select2>
          </div>
        </div>
      </td>
    </tr>
    <div class="modal fade" tabindex="-1" :id="`kt_modal_new_item_tax`">
      <div class="modal-dialog">
        <TaxForm @after-created="afterCreateTax" />
      </div>
    </div>
  </div>
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import TaxForm from "@/components/Taxe/TaxForm.vue";

const store = useStore()
const props = defineProps({
  item: {
    type: Object,
    default: {
      product_sale_element_id: '',
      taxes: []
    }
  },
  rate: { type: Number, default: 1 },
  symbol: String,
  id: Number,
  index: Number
})
const emits = defineEmits(["deleteItem"])

const products = computed(() => store.getters['products/getProductSaleElements'])
const taxes = computed(() => store.getters['taxes/getTaxes'])
const lots = computed(() => store.getters['products/getLots'])

const productLots = computed(() => {
  if(itemData.value.product_sale_element_id) 
    return lots.value.filter(lot => lot.product_sale_element_id === itemData.value.product_sale_element_id)
  return []
})


const total = computed(() => {
  const taxesSelected = taxes.value.filter(tax => itemData.value.taxes.includes(tax.id));
  let totalPrice = itemData.value.purchase_price * itemData.value.quantity;
  if(itemData.value.lot_id){
    const lot = lots.value.find(lot => lot.id === itemData.value.lot_id)
    if(lot)
      totalPrice = itemData.value.purchase_price * itemData.value.quantity * lot.lot.item_number
  }
  if (taxesSelected.length > 0) {
    const totalTaxePrice = taxesSelected.reduce((accumulator, tax) => {
      if (tax.type === 'amount') {
        accumulator.accAmount += parseFloat(tax.amount);
      } else {
        accumulator.accPercent += (totalPrice * parseFloat(tax.amount) / 100);
      }
      return accumulator;
    }, { accAmount: 0, accPercent: 0 });
    return totalPrice + totalTaxePrice.accAmount + totalTaxePrice.accPercent;
  }
  return totalPrice;
});

const itemData = ref(props.item)

function openTaxModal() {
  $("#kt_modal_new_item_tax").modal('toggle')
}

function afterCreateTax(tax) {
  $("#kt_modal_new_item_tax").modal('toggle')
  itemData.value.taxes.push(tax?.id)
}

function deleteRow(index) {
  emits('deleteItem', index)
}

function sortByKey(array, key) {
    return array.sort(function(a, b) {
      var x = a[key]?.toLowerCase();
      var y = b[key]?.toLowerCase();
      if (x < y) { return -1; }
      if (x > y) { return 1; }
      return 0;
    });
}

function filterProductSaleElements(key) {
  let productBeforeKey = [];
  for (let i = 0; i < key; i++) {
    const product = products.value[i];
    productBeforeKey.push(product.id);
  }
  let product_lists = products.value.filter(product => !productBeforeKey.includes(product.id));
  return sortByKey(product_lists, "name");
}

onMounted(() => {
})

</script>

<style scoped>
.table>:not(caption)>*>* {
  padding: 0 !important;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

/* Mobile : la ligne d'article devient une carte (produit et lot en pleine largeur,
   quantité / prix / montant côte à côte avec leur libellé) */
@media (max-width: 767.98px) {
  .purchase-item-row {
    flex-wrap: wrap;
    padding: 0.5rem;
  }
  .purchase-item-row > td.pi-full {
    flex: 0 0 100%;
    width: 100% !important;
    max-width: 100%;
    margin-bottom: 0.5rem;
  }
  .purchase-item-row > td.pi-third {
    flex: 0 0 33.333%;
    width: 33.333% !important;
    padding-right: 0.35rem !important;
  }
  .purchase-item-row > td.pi-third::before {
    content: attr(data-label);
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--kt-text-muted, #a1a5b7);
    margin-bottom: 0.25rem;
  }
}
</style>
